import { render, staticRenderFns } from "./pay_test.vue?vue&type=template&id=7dc0f93e&scoped=true&"
import script from "./pay_test.vue?vue&type=script&lang=js&"
export * from "./pay_test.vue?vue&type=script&lang=js&"
import style0 from "./pay_test.vue?vue&type=style&index=0&id=7dc0f93e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc0f93e",
  null
  
)

export default component.exports